import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { isDeskedByManager } from '@makemydeal/dr-sales-checkin-utils';
import { getWorkflowInputsFromState } from '../workflowInputs';
import type { WorkflowRule } from '../types';

// Showroom mode: manager approved, deal was created by a Dealmaker persona, and the deal has been
// published to Sales View. Outranks sentForDeskingRule — see the rule table in workflowEvaluator.ts.
export const deskedRule: WorkflowRule = (state: any): WorkflowStatus | null =>
    isDeskedByManager(getWorkflowInputsFromState(state)) ? WorkflowStatus.DESKED : null;
